import * as Styled from './styled'
import { NoMusicView } from './no-music-view'
import { SoundsList } from '../../components/sounds-list'
import DragDropUpload from 'components/DragDropUpload'
import { DragAreaActiveContent } from '../../components/drag-area-active-content'
import { audioSelectors } from 'store/features/audio/selectors'
import { useSelector } from 'react-redux'
import { IUserAudio } from 'store/types/audio'
import { IAudioItem } from 'types/audio'
import { useAudioUpload } from 'hooks/project-item-upload'
import { projectDataSelectors } from 'store/features/projectData/selectors'

export const MyMusic: React.FC = () => {
  const userMusic = useSelector(audioSelectors.userSounds)
  const uploadingAudios = useSelector(projectDataSelectors.uploadingAudios)

  const handleFilesUpload = useAudioUpload()

  if (!userMusic.length && !uploadingAudios.length) {
    return <NoMusicView />
  }

  return (
    <Styled.MyMusicWrapper>
      <DragDropUpload acceptType={'audio'} filesHandler={handleFilesUpload}>
        <DraggableSoundsList
          uploadingMusic={uploadingAudios}
          userMusic={userMusic}
        />
      </DragDropUpload>
    </Styled.MyMusicWrapper>
  )
}

const DraggableSoundsList: React.FC<{
  uploadingMusic: IAudioItem[]
  userMusic: IUserAudio[]
}> = ({ uploadingMusic, userMusic }) => {
  return (
    <>
      <DragAreaActiveContent />
      <SoundsList
        sounds={userMusic}
        uploadingSounds={uploadingMusic}
        isShowSoundDeleteBtn
      />
    </>
  )
}
